const getCssVariable = (varName) => {
	return getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
};

export const getTiptapColors = () => {
	return [
		getCssVariable("--tiptap-color-black"),
		getCssVariable("--tiptap-color-red"),
		getCssVariable("--tiptap-color-medical-blue"),
		getCssVariable("--tiptap-color-forest-green"),
		getCssVariable("--tiptap-color-gray"),
		getCssVariable("--tiptap-color-blue"),
	];
};

export const getTiptapColorNames = () => {
	return {
		[getCssVariable("--tiptap-color-black")]: "Black",
		[getCssVariable("--tiptap-color-red")]: "Red",
		[getCssVariable("--tiptap-color-medical-blue")]: "Medical Blue",
		[getCssVariable("--tiptap-color-forest-green")]: "Forest Green",
		[getCssVariable("--tiptap-color-gray")]: "Gray",
		[getCssVariable("--tiptap-color-blue")]: "Blue",
	};
};

// Fallback constants (for SSR or when CSS vars aren't available)
export const TIPTAP_COLORS = {
	BLACK: "#000000",
	RED: "#FF0000",
	MEDICAL_BLUE: "#0074CC",
	FOREST_GREEN: "#228B22",
	GRAY: "#808080",
	BLUE: "#0000FF",
};

export const HIGHLIGHT_COLORS = {
	YELLOW: "rgba(255, 249, 196, 0.8)",
	ORANGE: "rgba(255, 224, 178, 0.8)",
	RED: "rgba(255, 205, 210, 0.8)",
	BLUE: "rgba(207, 231, 250, 0.8)",
	PINK: "rgba(255, 224, 230, 0.8)",
	PURPLE: "rgba(237, 216, 253, 0.8)",
};

export const HIGHLIGHT_COLOR_NAMES = {
	[HIGHLIGHT_COLORS.YELLOW]: "Yellow",
	[HIGHLIGHT_COLORS.ORANGE]: "Orange",
	[HIGHLIGHT_COLORS.RED]: "Red",
	[HIGHLIGHT_COLORS.BLUE]: "Blue",
	[HIGHLIGHT_COLORS.PINK]: "Pink",
	[HIGHLIGHT_COLORS.PURPLE]: "Purple",
};

export const HIGHLIGHT_ICON_COLORS = {
	[HIGHLIGHT_COLORS.YELLOW]: "rgba(230, 190, 0, 0.9)",
	[HIGHLIGHT_COLORS.ORANGE]: "rgba(239, 139, 9, 0.9)",
	[HIGHLIGHT_COLORS.RED]: "rgba(229, 115, 115, 0.9)",
	[HIGHLIGHT_COLORS.BLUE]: "rgba(79, 149, 220, 0.9)",
	[HIGHLIGHT_COLORS.PINK]: "rgba(232, 116, 147, 0.9)",
	[HIGHLIGHT_COLORS.PURPLE]: "rgba(156, 86, 226, 0.9)",
};

export const getHighlightColors = () => Object.values(HIGHLIGHT_COLORS);

export const getHighlightColorNames = () => HIGHLIGHT_COLOR_NAMES;